import React, { useEffect, useState, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  useLocation
} from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { useLoader } from "../../../pages/LoaderContext";
import ValidationModal from "../common/ValidationModal"
import AutoSaveModal from "../common/AutoSaveModal"
import useIdle from '../../../hooks/useIdle';
import FileUpload from "../common/FileUpload";
import UploadList from "v2/components/common/UploadsList";
import circleArrowIcon from "../../../assets/images/circle-arrow-icon.svg"
import uploadIcon from "../../../assets/images/upload-icon.svg";



import * as yup from "yup";
import { Button, Card, CardContent, Stack, TextField, CircularProgress, Box, Typography, Tooltip } from "@mui/material";
import Grid from '@mui/material/Grid2';
import TextInput from "../common/TextInput";
import SelectDropdown from "../common/FormSelectDropdown";
import "./style.css";
import { makeStyles } from "@mui/styles";
// import {
//   getRisks,
//   createBcInformation,
//   getBcInformationDetails,
//   updatebBCInformation,
//   getInnoflexData
// } from "../../Services/api/projectService";
import { useProjectApiClient } from "../../Services/api/projectService"
import { useNavigate, useParams } from "react-router-dom";
import { successToast, errorToast } from "../../utils/toast";
import { ToastContainer } from "react-toastify";
import UnSavedModal from "../common/UnSavedModal"
import { useAppContext } from '../../../hooks/context/AppContext';
import { projectVersion } from "config/navConfig";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '60%',
    maxWidth: 'none',
    minHeight: '400px',
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  // '& .MuiDialogActions-root': {
  //   padding: theme.spacing(1),
  // },
}));

type InnoflexProject = {
  InnoflexID: string;
  MCO: string;
  ProjectFamily: string;
  ProjectMCO: string;
  // Add more fields if needed
};

interface AuditEntry {
  fieldName: string;
  oldValue: string;
  newValue: string;
}


const useStyles = makeStyles({
  themeButton: {
    backgroundColor: "#2a3fbf !important",
    padding: "8px 30px",
    fontWeight: "700",
    "&:hover": { backgroundColor: "#2a3fbf !important" },
  },
  cancelButton: {
    backgroundColor: "#d9d9d9 !important",
    color: "#626262 !important",
    padding: "8px 30px",
    fontWeight: "700",
    "&:hover": {
      backgroundColor: "#d9d9d9 !important",
      color: "#626262 !important",
    },
  },
});

const schema = yup.object().shape({
  Y1_Ito: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Y1 iTo must be a number")
    .required("Y1 iTo is required"),
  Y1_GTo: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Y1 GTo must be a number")
    .required("Y1 GTo is required"),
  Y1_Gm: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Y1 GM must be a number")
    .required("Y1 GM is required"),
  Capex: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Capex must be a number"),
  capexStatus: yup.string().required("Capex status is required"),
  Y3_Ito: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Y3 iTo must be a number")
    .required("Y3 iTo is required"),
  Y3_GTo: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Y3 GTo must be a number")
    .required("Y3 GTo is required"),
  Y3_Gm: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Y3 GM must be a number")
    .required("Y3 GM is required"),
  Payback: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("Payback must be a number"),
  Cpt: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("CPT must be a number"),
  cptStatus: yup.string().required("CPT status is required"),
  risk: yup
    .mixed()
    .nullable(),
  comment: yup.string().notRequired().nullable(),
});

const BcInformationForm: React.FC = () => {
  const location = useLocation();
  const { projectId, projectKey } = useParams<{ projectKey: string; projectId: string }>();
  const {
    getProjectDetails,
    getRisks,
    getCapexStatus,
    getCptStatus,
    createBcInformation,
    getBcInformationDetails,
    updatebBCInformation,
    getInnoflexData,
    getRequiredField,
    publishProjectOnSave,
    uploadProjectFile
  } = useProjectApiClient();
  const { appData, updateAppData, userData } = useAppContext();
  const navigate = useNavigate();
  const classes = useStyles();
  type SelectOption = { key: any; value: any };
  const [capexStatus, setCapexStatus] = useState([]);
  const [cptStatus, setCptStatus] = useState([]);
  const [risks, setRisks] = useState([]);
  const [isExisting, setIsExisting] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [showInnfoflexModal, setShowInnfoflexModal] = useState(false);
  const [innoflexKey, setInnoflexKey] = useState('');
  const [innoflexData, setInnoflexData] = useState<InnoflexProject[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const [selectedInnoflex, setSelectedInnoflex] = useState('');
  const { setLoading } = useLoader();
  const [validationErrors, setValidationErrors] = useState({})
  const [isValidationError, setIsValidationError] = useState(false)
  const [projectDetails, setProjectDetails] = useState({
    issaved: false
  })
  const [isDraftDisabled, setIsDraftDisabled] = useState(false);
  const [autoSaveModal, setAutoSaveModal] = React.useState<boolean>(false);
  const isIdle = useIdle(60000 * 10)
  const hasAutoSaved = useRef(false);
  const [isUpload, setIsUpload] = React.useState<boolean>(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);


  const [formData, setFormData] = useState({
    Y1_Ito: "",
    Y1_GTo: "",
    Y1_Gm: "",
    Capex: "",
    capexStatus: "",
    Y3_Ito: "",
    Y3_GTo: "",
    Y3_Gm: "",
    Payback: "",
    Cpt: "",
    cptStatus: "",
    comment: "",
    risk: "",
  });

  const [initialformData, setInitialformData] = useState({
    Y1_Ito: "",
    Y1_GTo: "",
    Y1_Gm: "",
    Capex: "",
    capexStatus: "",
    Y3_Ito: "",
    Y3_GTo: "",
    Y3_Gm: "",
    Payback: "",
    Cpt: "",
    cptStatus: "",
    comment: "",
    risk: "",
  });

  useEffect(() => {
    if (userData) {
      setIsDisabled(!userData.permissions.CanEdit)
    }
  }, [userData]);


  useEffect(() => {
    // @ts-ignore
    reset(formData);
  }, [formData]);


  const isEmptyObject = (obj: object) => {
    return JSON.stringify(obj) === '{}'
  };


  //  Fetch BC Information for Editing
  const fetchBcInformationDetails = async (key: any) => {
    try {
      const response = await getBcInformationDetails(projectKey);
      setLoading(false)
      // console.log(" Form Data response:", response);
      if (!isEmptyObject(response.data)) {
        setIsExisting(true)
        const bcData = response.data;
        let BcInformationData = {
          Y1_Ito: bcData.Y1_Ito !== null ? bcData.Y1_Ito : "",
          Y1_GTo: bcData.Y1_GTo !== null ? bcData.Y1_GTo : "",
          Y1_Gm: bcData.Y1_Gm !== null ? bcData.Y1_Gm : "",
          Capex: bcData.Capex !== null ? bcData.Capex : "",
          capexStatus: bcData.capexStatus ? JSON.stringify(bcData.capexStatus) : '',
          // capexStatus: JSON.stringify(bcData.capexStatus),
          Y3_Ito: bcData.Y3_Ito !== null ? bcData.Y3_Ito : "",
          Y3_GTo: bcData.Y3_GTo !== null ? bcData.Y3_GTo : "",
          Y3_Gm: bcData.Y3_Gm !== null ? bcData.Y3_Gm : "",
          Payback: bcData.Payback !== null ? bcData.Payback : "",
          Cpt: bcData.Cpt !== null ? bcData.Cpt : "",
          // cptStatus: JSON.stringify(bcData.cptStatus),
          cptStatus: bcData.cptStatus ? JSON.stringify(bcData.cptStatus) : '',
          comment: bcData.comment || "",
          risk: JSON.stringify(bcData.risk_Key)
        };

        setFormData(BcInformationData);
        setInitialformData(BcInformationData)

        //  Use `setValue` to update form fields in react-hook-form
        Object.keys(BcInformationData).forEach((key) => {
          setValue(key as any, BcInformationData[key as keyof typeof BcInformationData]);
        });

        // console.log(" Form Data Populated:", BcInformationData);
      }
    } catch (error) {
      console.error(" Failed to fetch BC Information data:", error);
    }
  };
  const {
    handleSubmit,
    control,
    clearErrors,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  //  Fetch Risks
  const fetchRisks = async () => {
    try {
      const data = await getRisks();
      let output = data.map((item: any) => ({
        key: item.Risk_key,
        value: item.Risk_name
      }));
      // @ts-ignore
      setRisks(output)
    } catch (error) {
      console.error(" Failed to fetch risk:", error);
    } finally {
    }
  };


  const fetchCapexStatus = async () => {
    try {
      const data = await getCapexStatus();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setCapexStatus(output)
    } catch (error) {
      console.error(" Failed to fetch capex status:", error);
    } finally {
    }
  };
  const fetchCptStatus = async () => {
    try {
      const data = await getCptStatus();
      let output = data.map((item: any) => ({
        key: item.Lookup_Key,
        value: item.Valuez
      }));
      setCptStatus(output)
    } catch (error) {
      console.error(" Failed to fetch cpt status:", error);
    } finally {
    }
  };

  useEffect(() => {
    let check = JSON.stringify(formData) === JSON.stringify(initialformData);
    if (!check) {
      updateAppData({ isFormChanged: true, showUnSavedModal: false });
    } else {
      updateAppData({ isFormChanged: false, showUnSavedModal: false });
    }

  }, [formData]);

  useEffect(() => {
    if (isIdle && !autoSaveModal) {
      let check = JSON.stringify(formData) === JSON.stringify(initialformData);
      if (!check && !hasAutoSaved.current) {
        setAutoSaveModal(true);
      }
    }
  }, [isIdle]);

  //  Fetch existing BC Information if editing
  useEffect(() => {
    setLoading(true)
    const fetchOptions = async () => {
      await Promise.all([
        fetchRisks(),
        fetchCapexStatus(),
        fetchCptStatus(),
        fetchsProjectDetails()
      ]);
    };
    fetchOptions();
    if (projectKey) {
      fetchBcInformationDetails(projectKey);
    }
  }, [projectKey]);

  const fetchsProjectDetails = async () => {
    try {
      const data = await getProjectDetails(projectId);
      if (data) {
        setProjectDetails({ issaved: data.issaved })
        setIsDraftDisabled(data.issaved)
      }

    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {
    }
  };


  //  Handle Form Change
  let handleFormChange = (name: string, value: any) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    hasAutoSaved.current = false;
  };

  let handleFilterChange = async (name: any, value: any) => {
    setFormData({
      ...formData,
      [name]: value
    })
    hasAutoSaved.current = false;
  }

  const handleFormSubmit = (type: any, url: string) => {
    return handleSubmit((data) => onSubmit(data, type, url));
  };

  let groupByModule = (errors: any) => {
    return errors.reduce((grouped: any, error: any) => {
      const { ModuleName, Message } = error;
      if (!grouped[ModuleName]) {
        grouped[ModuleName] = [];
      }
      grouped[ModuleName].push(Message);
      return grouped;
    }, {});
  }

  const fetchRequiredField = async () => {
    try {
      const data = await getRequiredField(projectKey);
      return data
    } catch (error) {
      console.error(" Failed to fetch projects:", error);
    } finally {

    }
  };
  let pubLishProjectData = async () => {
    let res = await publishProjectOnSave(projectKey)
    if (res && res.issaved !== undefined) {
      setProjectDetails({ issaved: res.issaved });
      setIsDraftDisabled(res.issaved)
    }
  }

  const getCompleteAuditTrail = (initialData: Record<string, any>, updatedData: Record<string, any>): AuditEntry[] => {
    const audit: AuditEntry[] = [];
    const keys = Object.keys(initialData);
    for (const key of keys) {
      if (key === 'project_id') continue;

      const oldValue = initialData[key];
      const newValue = updatedData[key];

      audit.push({
        fieldName: key,
        oldValue: String(oldValue),
        newValue: String(newValue)
      });
    }

    return audit;
  }

  const onSubmit = async (data: any, type: any, url: string) => {
    let resField = await fetchRequiredField()
    if (resField?.data && resField?.data.filter((val: any) => val.ModuleName !== "BC Information").length) {
      const groupedErrors = groupByModule(resField?.data.filter((val: any) => val.ModuleName !== "BC Information"));
      setValidationErrors(groupedErrors)
      setIsValidationError(true)
      return
    }
    try {
      setLoading(true)
      let payload = {
        project_key: projectKey,
        Y1_Ito: formData.Y1_Ito,
        Y1_GTo: formData.Y1_GTo,
        Y1_Gm: formData.Y1_Gm,
        Capex: formData.Capex,
        Y3_Ito: formData.Y3_Ito,
        Y3_GTo: formData.Y3_GTo,
        Y3_Gm: formData.Y3_Gm,
        Payback: formData.Payback,
        Cpt: formData.Cpt,
        capexStatus: formData.capexStatus,
        comment: formData.comment,
        risk_Key: formData.risk,
        cptStatus: formData.cptStatus,

      };
      let initialPayload = {
        project_key: projectKey,
        Y1_Ito: initialformData.Y1_Ito,
        Y1_GTo: initialformData.Y1_GTo,
        Y1_Gm: initialformData.Y1_Gm,
        Capex: initialformData.Capex,
        Y3_Ito: initialformData.Y3_Ito,
        Y3_GTo: initialformData.Y3_GTo,
        Y3_Gm: initialformData.Y3_Gm,
        Payback: initialformData.Payback,
        Cpt: initialformData.Cpt,
        comment: initialformData.comment,
        risk_Key: initialformData.risk,
        cptStatus: initialformData.cptStatus,
        capexStatus: initialformData.capexStatus,
      };
      const completeAuditTrail = getCompleteAuditTrail(initialPayload, payload);
      {/* @ts-ignore */ }
      payload.audit = completeAuditTrail;
      if (!isExisting) {
        await createBcInformation(payload);
        updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
        successToast("BC Information saved successfully!");
        await pubLishProjectData()
        setProjectDetails({ issaved: true });
        setIsDraftDisabled(true)
        setLoading(false)
        setTimeout(() => {
          navigate(url ? url : `${projectVersion}/project/bc-information/${projectId}/${projectKey}`);
        }, 2000);
      } else {
        {/* @ts-ignore */ }
        //return console.log("payloadpayloadpayloadpayload",payload);
        let res = await updatebBCInformation(payload, projectKey)
        updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
        if (res) {
          if (projectKey) {
            fetchBcInformationDetails(projectKey);
          }
          {/* @ts-ignore */ }
          successToast(res.message)
          await pubLishProjectData()
          setProjectDetails({ issaved: true });
          setIsDraftDisabled(true)
          setLoading(false);
          setTimeout(() => {
            navigate(`${projectVersion}/project/bc-information/${projectId}/${projectKey}`);
          }, 2000);
        }
      }
    } catch (error) {
      console.error(" Error submitting form:", error);
    }
  };
  const saveDraft = async (url: string) => {
    if (!projectKey) {
      console.error(" Error: Missing project_key in localStorage");
      return;
    }
    else {
      try {
        setLoading(true)
        let payload = {
          project_key: projectKey,
          Y1_Ito: watch('Y1_Ito'),
          Y1_GTo: watch('Y1_GTo'),
          Y1_Gm: watch("Y1_Gm"),
          Capex: watch("Capex"),
          capexStatus: watch("capexStatus"),
          Y3_Ito: watch("Y3_Ito"),
          Y3_GTo: watch("Y3_GTo"),
          Y3_Gm: watch("Y3_Gm"),
          Payback: watch("Payback"),
          Cpt: watch("Cpt"),
          comment: watch("comment"),
          risk_Key: watch("risk"),
          cptStatus: watch("cptStatus")
        };
        if (!isExisting) {
          await createBcInformation(payload);
          setLoading(false)
          updateAppData({ isFormChanged: false, showUnSavedModal: false });
          successToast("BC Information saved successfully!");
          reset();
          setTimeout(() => {
            navigate(url ? url : `${projectVersion}/project/technical-scope/${projectId}/${projectKey}`);
          }, 2000);
        } else {
          {/* @ts-ignore */ }
          let res = await updatebBCInformation(payload, projectKey)
          if (projectKey) {
            fetchBcInformationDetails(projectKey);
          }
          setLoading(false)
          updateAppData({ isFormChanged: false, showUnSavedModal: false });
          if (res) {
            {/* @ts-ignore */ }
            successToast(res.message)
            setTimeout(() => {
              navigate(`${projectVersion}/project/technical-scope/${projectId}/${projectKey}`);
            }, 2000);
          }
        }
      } catch (error) {
        console.error(" Error submitting form:", error);
      }
    }

  };

  let closeUnSavedModal = () => {
    updateAppData({ isFormChanged: true, showUnSavedModal: false, url: '' });
  }
  let saveUnSavedModal = () => {
    handleFormSubmit(true, appData.url)()
  }
  let draftSavedModal = () => {
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    //  handleFormSubmit(false, appData.url)()
    saveDraft(appData.url)
  }
  const discardModal = () => {
    // reset form, redirect, or just close modal
    updateAppData({ isFormChanged: false, showUnSavedModal: false, url: appData.url });
    navigate(appData.url);
  };

  let handleCancel = () => {
    if (!appData.isFormChanged) {
      navigate(`${projectVersion}/projects-grid`)
    } else {
      updateAppData({ isFormChanged: true, showUnSavedModal: true });
    }

  }

  let handleInnoflexClose = () => {
    setIsSearched(false)
    setShowInnfoflexModal(false)
    setInnoflexData([])
  }

  let handleInnoflex = () => {
    setShowInnfoflexModal(true)
  }

  let searchInnoflex = async () => {
    if (!innoflexKey) return
    setIsSearching(true)
    let res = await getInnoflexData(innoflexKey)
    setIsSearched(true)
    setIsSearching(false)
    setInnoflexKey('')
    if (res.data) {
      setInnoflexData(res.data)
    }
  }

  let handleInnoSelext = (val: any) => {
    setSelectedInnoflex(val?.InnoflexID)
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      searchInnoflex()
    }
  };
  let applyInnoflex = () => {
    if (!selectedInnoflex) return
    {/* @ts-ignore */ }
    let obj = innoflexData.find(val => val.InnoflexID === selectedInnoflex)

    let BcInformationData: any = {
      ...formData,
      //  @ts-ignore 
      Y1_Ito: obj.Y1iTO !== null ? obj.Y1iTO : '', Y1_GTo: obj.Y1GTO !== null ? obj.Y1GTO : '', Y1_Gm: obj.Y1GM !== null ? obj.Y1GM : '', Capex: obj.CAPEX !== null ? obj.CAPEX : '', Y3_Ito: obj.Y3iTO !== null ? obj.Y3iTO : '', Y3_GTo: obj.Y3GTO !== null ? obj.Y3GTO : '', Y3_Gm: obj.Y3GM !== null ? obj.Y3GM : '', Payback: obj.Payback !== null ? obj.Payback : ''

    }
    setFormData(BcInformationData);
    //setInitialformData(BcInformationData); 
    handleInnoflexClose()
  }
  let closeValidationModal = () => {
    setIsValidationError(false)
    setValidationErrors({})
  }


  const autoSave = async () => {
    setAutoSaveModal(false);
    try {
      let resField = await fetchRequiredField()
      if (resField?.data && resField?.data.length) {
        await saveDraft('');
        hasAutoSaved.current = true;
      } else {
        await handleFormSubmit(true, '')();
        hasAutoSaved.current = true;
      }
    } catch (error) {
      console.error("Auto-save failed:", error);
    }
  };

  let closeAutoSave = () => {
    setAutoSaveModal(false)
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const uploadFlag = searchParams.get("isUpload") === "true";
    if (uploadFlag) {
      setIsUpload(true);
      searchParams.delete("isUpload");
    }
  }, [location.search, location.pathname]);

  let handlebackUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete("isUpload");

    navigate(
      {
        pathname: location.pathname,
        search: searchParams.toString()
          ? `?${searchParams.toString()}`
          : "", // no query string if empty
      },
      { replace: true }
    );

    setIsUpload(false);
  };

  const handleProjectFileChange = async (file: any) => {
    const allowedTypes = [
      'application/pdf',
      'application/msword',                       // .doc
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/vnd.ms-excel',                 // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',       // .xlsx
      'application/vnd.ms-powerpoint',            // .ppt
      'application/vnd.openxmlformats-officedocument.presentationml.presentation' // .pptx
    ];
    if (!allowedTypes.includes(file.type)) {
      errorToast('Only PDF, PPT, XLS or DOC formats are allowed.');
      return;
    }
    setLoading(true)
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB in bytes
    if (file.size > MAX_FILE_SIZE) {
      errorToast('File size must be less than 5 MB');
      return;
    }
    try {
      const formdata = new FormData();
      formdata.append("file", file, file.name);
      let data = await uploadProjectFile(projectKey, 3, formdata);
      //  successToast(data.message)
      setLoading(false)
      setRefreshTrigger(prev => prev + 1);

    } catch (error) {
      console.error('Error uploading file:', error);
      errorToast('Failed to upload file. Please try again.');
    }
  };

  let handleClickUpload = () => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("isUpload", "true");

    navigate(
      {
        pathname: location.pathname,
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
    setIsUpload(true);
  };


  return (
    <>
      <ToastContainer />
      <div className="create-project-content">
        <Card className="" sx={{ padding: "10px" }}>
          <CardContent>

            <div className="button-top-form" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Stack
                direction="row"
                spacing={2}
                sx={{ justifyContent: "start", pb: 4 }}
              >
                {
                  isUpload ?
                    <Button onClick={() => handlebackUpload()} sx={{ border: '0px', fontSize: '14px', color: '#B5B5B5', p: 0, textTransform: 'capitalize' }}><img src={circleArrowIcon} className="wtsback--img" /></Button>
                    :
                    <Button
                      disabled={isDisabled}
                      onClick={handleInnoflex}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                        color: 'white !important',
                        backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}`
                      }}
                      className={classes.themeButton}
                    >
                      Populate Innoflex
                    </Button>
                }

              </Stack>
              {
                !isUpload ?
                  <Stack
                    direction="row"
                    spacing={2}
                    sx={{ justifyContent: "end", pb: 4 }}
                  >
                    {
                      localStorage.user_info && JSON.parse(localStorage.user_info).Role !== '' ?
                        JSON.parse(localStorage.user_info).Role !== 'ProjectViewer' ?
                          <Tooltip title="Upload Documents" arrow>
                            <Button
                              onClick={() => handleClickUpload()}
                              sx={{ p: 0, minWidth: 'auto', width: '38px', height: '38px', border: '1px solid #000', borderRadius: '50%' }}
                            >
                              <img src={uploadIcon} className="icon-wt-uplad" />
                            </Button>
                          </Tooltip>
                          :
                          <>
                          </>
                        :
                        null
                    }

                    <Button
                      disabled={isDisabled}
                      onClick={handleFormSubmit(true, '')}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                        color: 'white !important',
                        backgroundColor: `${isDisabled ? '#d9d9d9 !important' : '#2a3fbf !important'}`
                      }}
                      className={classes.themeButton}
                    >
                      Submit
                    </Button>
                    <Button
                      disabled={isDisabled || projectDetails.issaved}
                      onClick={() => saveDraft('')}
                      variant="contained"
                      sx={{
                        borderRadius: '30px',
                        px: 4,
                        py: 1,
                        textTransform: 'capitalize',
                        color: 'white !important',
                        backgroundColor: '#2a3fbf !important',
                        '&.Mui-disabled': {
                          backgroundColor: '#d9d9d9 !important',
                          color: '#5f6368 !important'
                        }
                      }}
                      className={classes.themeButton}
                    >
                      Draft & Continue
                    </Button>
                    <Button
                      disabled={isDisabled}
                      onClick={handleCancel}
                      variant="contained"
                      sx={{
                        borderRadius: "30px",
                        px: 4,
                        py: 1,
                        textTransform: "capitalize",
                      }}
                      className={classes.cancelButton}
                    >
                      Cancel
                    </Button>
                  </Stack>
                  :
                  <>
                    <div className="file-upload-button">
                      <FileUpload isProjectUpload={true} isDisabled={false} onFileChange={handleProjectFileChange}
                        name="uploadPic" label="Browse" control={control} errors={errors} />
                    </div>
                  </>

              }

            </div>

            {
              isUpload ?
                <>
                  {/* @ts-ignore */}
                  <UploadList refreshTrigger={refreshTrigger} setLoading={setLoading} moduleId={3}></UploadList>
                </>
                :
                <form noValidate>
                  <Grid container spacing={3}>
                    <Grid size={12}>
                      {
                        !isUpload ?
                          <h5 className="txt-mandatory-title">*Fields are mandatory</h5>
                          :
                          null

                      }
                    </Grid>
                    <Grid size={4}>
                      <label className="txt-label-input">
                        Y1 iTo<span className="required-txt">*</span>
                      </label>
                      <TextInput
                        isDisabled={isDisabled}
                        name="Y1_Ito"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) => handleFormChange(e.target.name, e.target.value)}
                        onlyFourDecimal={true}
                        showEuro={true}
                      />

                    </Grid>
                    {/* New field for Y1 GTO added */}
                    <Grid size={4}>
                      <label className="txt-label-input">
                        Y1 GTo<span className="required-txt">*</span>
                      </label>
                      <TextInput
                        isDisabled={isDisabled}
                        name="Y1_GTo"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) => handleFormChange(e.target.name, e.target.value)}
                        onlyFourDecimal={true}
                        showEuro={true}
                      />

                    </Grid>

                    <Grid size={4}>
                      <label className="txt-label-input">
                        Y1 GM<span className="required-txt">*</span>
                      </label>
                      <TextInput
                        isDisabled={isDisabled}
                        name="Y1_Gm"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) => handleFormChange("Y1_Gm", e.target.value)}
                        percentageWithTwoDecimals={true}
                        showPercentage={true}
                      />
                    </Grid>

                    <Grid size={4}>
                      <label className="txt-label-input">
                        Y3 iTo<span className="required-txt">*</span>
                      </label>
                      <TextInput
                        isDisabled={isDisabled}
                        name="Y3_Ito"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) => handleFormChange("Y3_Ito", e.target.value)}
                        onlyFourDecimal={true}
                        showEuro={true}
                      />
                    </Grid>
                    <Grid size={4}>
                      <label className="txt-label-input">
                        Y3 GTo<span className="required-txt">*</span>
                      </label>
                      <TextInput
                        isDisabled={isDisabled}
                        name="Y3_GTo"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) => handleFormChange(e.target.name, e.target.value)}
                        onlyFourDecimal={true}
                        showEuro={true}
                      />
                    </Grid>
                    <Grid size={4}>
                      <label className="txt-label-input">
                        Y3 GM<span className="required-txt">*</span>
                      </label>
                      <TextInput
                        isDisabled={isDisabled}
                        name="Y3_Gm"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) => handleFormChange("Y3_Gm", e.target.value)}
                        percentageWithTwoDecimals={true}
                        showPercentage={true}
                      />
                    </Grid>


                    <Grid size={4}>
                      <label className="txt-label-input">Capex Status <span className="required-txt">*</span></label>
                      <div className="project_drpdnw">
                        <Controller
                          name="capexStatus"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("capexStatus", val);
                                clearErrors("capexStatus");
                              }}
                              options={capexStatus}
                              isError={errors.capexStatus ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.capexStatus && (
                        <p className="error-message">{errors.capexStatus.message}</p>
                      )}
                    </Grid>
                    <Grid size={4}>
                      <label className="txt-label-input">
                        Capex
                      </label>
                      <TextInput
                        isDisabled={isDisabled}
                        name="Capex"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) => handleFormChange("Capex", e.target.value)}
                        onlyFourDecimal={true}
                        showEuro={true}
                      />
                    </Grid>
                    <Grid size={4}>
                      <label className="txt-label-input"> Payback </label>
                      <TextInput
                        isDisabled={isDisabled}
                        name="Payback"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) =>
                          handleFormChange("Payback", e.target.value)
                        }
                        showInYears={true}
                      />
                    </Grid>

                    <Grid size={4}>
                      <label className="txt-label-input">CPT Status <span className="required-txt">*</span> </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="cptStatus"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("cptStatus", val);
                                clearErrors("cptStatus");
                              }}
                              options={cptStatus}
                              isError={errors.cptStatus ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.cptStatus && (
                        <p className="error-message">{errors.cptStatus.message}</p>
                      )}
                    </Grid>

                    <Grid size={4}>
                      <label className="txt-label-input"> CPT </label>
                      <TextInput
                        isDisabled={isDisabled}
                        name="Cpt"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) => handleFormChange("Cpt", e.target.value)}
                        onlyFourDecimal={true}
                        showEuroWithoutMillion={true}
                      />
                    </Grid>

                  </Grid>
                  <Grid container spacing={3} mt={2}>
                    <Grid size={8}>
                      <label className="txt-label-input">Comment </label>
                      <TextInput
                        isDisabled={isDisabled}
                        className="comment-input" isComment={true}
                        name="comment"
                        label=""
                        control={control}
                        errors={errors}
                        onChange={(e) =>
                          handleFormChange("comment", e.target.value)
                        }
                        multiline
                      />
                    </Grid>
                    <Grid size={4}>
                      <label className="txt-label-input">Business Case Risk  </label>
                      <div className="project_drpdnw">
                        <Controller
                          name="risk"
                          control={control}
                          render={({ field }) => (
                            <SelectDropdown
                              isDisabled={isDisabled}
                              filterKey=""
                              label=""
                              value={field.value}
                              onChange={(val) => {
                                field.onChange(val);
                                handleFilterChange("risk", val);
                                clearErrors("risk");
                              }}
                              options={risks}
                              isError={errors.risk ? true : false}
                            />
                          )}
                        />
                      </div>
                      {errors.risk && (
                        <p className="error-message">{errors.risk.message}</p>
                      )}
                    </Grid>
                  </Grid>
                </form>
            }
          </CardContent>
        </Card>
      </div>
      {/* @ts-ignore */}
      <UnSavedModal close={closeUnSavedModal} saveUnSavedModal={saveUnSavedModal} draftSavedModal={draftSavedModal} discardModal={discardModal} isDraftDisabled={isDraftDisabled} />


      <BootstrapDialog
        onClose={handleInnoflexClose}
        aria-labelledby="customized-dialog-title"
        open={showInnfoflexModal}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            p: 2,
          },
        }}
      >
        <DialogContent sx={{ textAlign: 'center' }}>
          {/* Header */}
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{ color: '#333', mb: 2 }}
          >
            Search Innoflex Project
          </Typography>

          {/* Input Field */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              border: '1px solid #ccc',
              borderRadius: '6px',
              px: 1.5,
              py: 0.5, // Reduced vertical padding
              mb: 2,
              height: '36px', // You can tweak this to make it even smaller
            }}
          >
            <TextField
              fullWidth
              variant="standard"
              placeholder="Type project name..."
              onKeyDown={handleKeyDown}
              onChange={(e) => setInnoflexKey(e.target.value)}
              inputProps={{
                style: {
                  fontSize: '14px', // Smaller text
                  padding: '4px 0', // Less vertical padding inside input
                },
              }}
              InputProps={{ disableUnderline: true }}
            />
            <IconButton
              onClick={searchInnoflex}
              sx={{ p: '4px' }} // Smaller icon button padding
            >
              <i className="fas fa-search" />
            </IconButton>
          </Box>

          {/* Table or Message */}
          {isSearching ? (
            <Box display="flex" justifyContent="center" mt={2}>
              <CircularProgress size={24} sx={{ color: '#2b3fbf' }} />
            </Box>
          ) : innoflexData.length ? (
            <TableContainer className="innfoFlexsearchTable" sx={{ maxHeight: 200, borderRadius: 2 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Select</TableCell>
                    <TableCell>MCO</TableCell>
                    <TableCell>Project Family</TableCell>
                    <TableCell>Project MCO</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {innoflexData.map((val) => (
                    <TableRow key={val?.InnoflexID} hover>
                      <TableCell>
                        <FormControl>
                          <RadioGroup>
                            <FormControlLabel
                              checked={selectedInnoflex === val?.InnoflexID}
                              value={val?.InnoflexID}
                              control={<Radio size="small" />}
                              label=""
                              onClick={() => handleInnoSelext(val)}
                            />
                          </RadioGroup>
                        </FormControl>
                      </TableCell>
                      <TableCell>{val?.MCO}</TableCell>
                      <TableCell>{val?.ProjectFamily}</TableCell>
                      <TableCell>{val?.ProjectMCO}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Typography variant="body2" sx={{ mt: 1 }}>
              {isSearched ? 'No results found' : 'Please enter name to search!'}
            </Typography>
          )}
        </DialogContent>

        {/* Footer Actions */}
        <DialogActions sx={{ justifyContent: 'right', pb: 2 }}>
          <Button
            onClick={handleInnoflexClose}
            sx={{
              backgroundColor: '#f0f0f0',
              borderRadius: '20px',
              color: '#333',
              px: 3,
              py: 1,
              fontWeight: 500,
              '&:hover': {
                backgroundColor: '#e0e0e0',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={applyInnoflex}
            sx={{
              backgroundColor: '#2a3fbf',
              borderRadius: '20px',
              color: '#fff',
              px: 3,
              py: 1,
              fontWeight: 500,
              ml: 2,
              '&:hover': {
                backgroundColor: '#1d2e9f',
              },
            }}
          >
            Apply
          </Button>
        </DialogActions>
      </BootstrapDialog>
      <ValidationModal validationErrors={validationErrors} open={isValidationError} closeValidationModal={closeValidationModal} />
      <AutoSaveModal open={autoSaveModal} closeAutoSave={closeAutoSave} autoSave={autoSave} ></AutoSaveModal>

    </>
  );
};

export default BcInformationForm;
